module.exports = __webpack_public_path__ + "img/x-red.9bcbb5c7.svg";